import { useState, useEffect } from "react";

function useCurrentPath() {
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentPath(window.location.pathname + window.location.search);
    }
  }, []);

  return currentPath;
}

export default useCurrentPath;
